export enum RouteNames {
  Root = "Routine",
  Agenda = "Agenda",
  Calendar = "Calendar",
  Organization = "Organization",
  Workspace = "Workspace",
  Install = "Install",
  RecurrentTask = "Recurrent Task",
  Event = "Event",
  Person = "Person",
  Assistant = "Assistant",
  Agent = "Agent",
  AgentConversation = "Agent / Conversation",
  AgentConfiguration = "Agent / Configuration",
  Canvas = "Canvas",
  Contacts = "Contacts",
  Inbox = "Inbox",
  Database = "Database",
  Object = "Object",
  Automation = "Automation",
  AutomationRunDetail = "Automation Run Detail",
  Upcoming = "Upcoming",
  Journal = "Journal",
  Meetings = "Meetings",
  Labels = "Labels",
  Label = "Label",
  OrgTasks = "Organization / Tasks",
  OrgTask = "Organization / Task",
  OrgProjects = "Organization / Projects",
  OrgPages = "Organization / Pages",
  OrgPage = "Organization / Page",
  OrgJournal = "Organization / Journal",
  OrgContacts = "Organization / Contacts",
  OrgLabels = "Organization / Labels",
  Settings = "Settings",
  SettingsCalendars = "Settings / Calendars",
  SettingsMeetings = "Settings / Meetings",
  SettingsPreferences = "Settings / Preferences",
  SettingsMenu = "Settings / Menu",
  SettingsIntegrations = "Settings / Integrations",
  SettingsTypes = "Settings / Types",
  SettingsTypeEdition = "Settings / Type Edition",
  SettingsTypeCreation = "Settings / Type Creation",
  SettingsIntegrationsNotion = "Settings / Integrations / Notion",
  SettingsIntegrationsNotionSetup = "Settings / Integrations / Notion / Setup",
  SettingsIntegrationsGmail = "Settings / Integrations / Gmail",
  SettingsIntegrationsGmailConsent = "Settings / Integrations / Gmail / Grant",
  SettingsIntegrationsGoogleWorkspace = "Settings / Integrations / Google Workspace",
  SettingsIntegrationsGoogleCalendar = "Settings / Integrations / Google Calendar",
  SettingsIntegrationsGoogleContacts = "Settings / Integrations / Google Contacts",
  SettingsMembraneIntegration = "Settings / Integrations / Membrane / Integration",
  SettingsMembraneAddDataCollection = "Settings / Integrations / Membrane / Add Data Collection",
  SettingsMcpIntegration = "Settings / Integrations / MCP / Integration",
  SettingsDashboard = "Settings / Dashboard",
  SettingsArchive = "Settings / Archive",
  SettingsInvite = "Settings / Invite",
  SettingsLogs = "Settings / Logs",
  SettingsAccount = "Settings / Account",
  SettingsApps = "Settings / Apps",
  SettingsTaskBindings = "Settings / Task Bindings",
  SettingsPermissions = "Settings / Permissions",
  SettingsOrganization = "Settings / Organization",
  SettingsPlan = "Settings / Organization / Plan",
  SettingsPlugins = "Settings / Plugins",
  SettingsCustomMcpClients = "Settings / Custom MCP Clients",
  SettingsPeople = "Settings / Organization / People",
  SettingsWorkspaces = "Settings / Organization / Workspaces",
  SettingsWorkspace = "Settings / Organization / Workspace",
  SettingsWorkspaceUsers = "Settings / Organization / Workspace / Members",
  SettingsWorkspaceTaskBindings = "Settings / Organization / Workspace / Task Bindings",
  SettingsAgents = "Settings / Organization / Agents",
  SettingsAutomations = "Settings / Organization / Automations",
  SettingsAutomation = "Settings / Organization / Automation",
  SettingsStudio = "Settings / Organization / Studio",
  Signin = "Sign In",
  Signup = "Sign Up",
  NotFound = "Not Found",
}
